#import "./StaffTrainingModuleFields.graphql"

query GetMyTrainingModule($slug: String!) {
  myTrainingModule(slug: $slug) {
    ...StaffTrainingModuleFields
  }
}
